import { initializeApp, getApps } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, signOut } from "firebase/auth";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const auth = () => getAuth(getApps()[0] || initializeApp(config));
let verifier = null;

export async function sendPhoneCode(phone10, containerId) {
  const a = auth();
  if (verifier) { verifier.clear(); verifier = null; }
  verifier = new RecaptchaVerifier(a, containerId, { size: "invisible" });
  return signInWithPhoneNumber(a, `+91${phone10}`, verifier);
}

export async function confirmPhoneCode(confirmation, code) {
  const cred = await confirmation.confirm(code);
  const token = await cred.user.getIdToken();
  signOut(auth()).catch(() => {});
  return token;
}

export function firebaseErrorMessage(e) {
  const c = e?.code || "";
  if (c.includes("invalid-phone-number")) return "Enter a valid 10-digit mobile number";
  if (c.includes("too-many-requests") || c.includes("quota")) return "Too many attempts. Try again later or use Email.";
  if (c.includes("invalid-verification-code")) return "Wrong code. Please check and try again.";
  if (c.includes("code-expired")) return "Code expired. Tap Resend code.";
  if (c.includes("captcha") || c.includes("unauthorized-domain") || c.includes("operation-not-allowed") || c.includes("configuration-not-found")) return "SMS login isn't available right now. Please use Email.";
  return "Could not send SMS. Please try again or use Email.";
}
